import { forwardRef, useImperativeHandle, useState } from "react";
import { ClipboardCalc } from "./ImportUtils";
import { FormControl, InputLabel, MenuItem, TableCell, TableRow, TextField, Tooltip } from "@mui/material";
import { CustomPropertyType } from "generated/graphql";
import PSelect from "components/PSelect";
import { EllipsisSX } from "theme";
import { P } from "theme/typography";

export const EditableClipboardCalc = forwardRef<
  ClipboardCalc,
  {
    calc: ClipboardCalc;
  }
>(function EditableClipboardCalc({ calc }, ref) {
  const [key, setKey] = useState(calc.key);
  const [type, setType] = useState(calc.dataType);
  const [selectOptions, setSelectOptions] = useState(calc.selectOptions);

  useImperativeHandle(
    ref,
    () => ({
      ...calc,
      key,
      dataType: type,
      selectOptions,
    }),
    [key, type, selectOptions]
  );

  return (
    <TableRow>
      <TableCell>{calc.displayName}</TableCell>
      <TableCell>
        <TextField value={key} onChange={(e) => setKey(e.target.value)} />
      </TableCell>
      <TableCell
        sx={{
          maxWidth: 200,
        }}>
        <Tooltip title={calc.description}>
          <P sx={EllipsisSX}>{calc.description}</P>
        </Tooltip>
      </TableCell>
      <TableCell>
        <FormControl fullWidth>
          <InputLabel>Data Type</InputLabel>
          <PSelect
            label="Data Type"
            value={type}
            onChange={(e) => {
              const dt = e.target.value as CustomPropertyType;
              setType(dt);
              if (dt !== CustomPropertyType.Select) {
                setSelectOptions([]);
              }
            }}>
            <MenuItem value={CustomPropertyType.Text}>Text</MenuItem>
            <MenuItem value={CustomPropertyType.Date}>Date</MenuItem>
            <MenuItem value={CustomPropertyType.Number}>Number</MenuItem>
            <MenuItem value={CustomPropertyType.Select}>Select</MenuItem>
            <MenuItem value={CustomPropertyType.Json}>JSON</MenuItem>
          </PSelect>
        </FormControl>
      </TableCell>
      <TableCell>
        {calc.dataType === CustomPropertyType.Select ? (
          <PSelect defaultValue={selectOptions[0]}>
            {selectOptions.map((o) => (
              <MenuItem value={o} key={o}>
                {o}
              </MenuItem>
            ))}
          </PSelect>
        ) : (
          <></>
        )}
      </TableCell>
      <TableCell>{calc.isCollectVisible ? "Yes" : "No"}</TableCell>
    </TableRow>
  );
});
